//
//  src/components/analytics/GoogleAnalytics.js
//
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


//
//  google analytics
//
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
}
